import type { ReactNode } from 'react';

/**
 * Regla contra el espacio vacío: el contenido se **centra** y su ancho máximo
 * depende del tipo de vista. Nada de contenido pegado a la izquierda con una
 * franja muerta al lado en un monitor ancho.
 */
type Ancho = 'texto' | 'formulario' | 'panel' | 'ancho' | 'completo';

const MAXIMOS: Record<Ancho, string> = {
  texto: 'max-w-2xl', // lectura, detalle angosto
  formulario: 'max-w-xl', // formularios de una columna
  panel: 'max-w-5xl', // ficha, panel a dos columnas
  ancho: 'max-w-7xl', // listas y tableros
  completo: 'max-w-none', // ocupa todo
};

export function Contenedor({
  ancho = 'ancho',
  children,
  className = '',
}: {
  ancho?: Ancho;
  children: ReactNode;
  className?: string;
}) {
  return <div className={`mx-auto w-full ${MAXIMOS[ancho]} ${className}`}>{children}</div>;
}
